import { Template } from "types/landlord/verificationTemplate";

export const getTemplateIdentifier = (
  template: Template | undefined
): string => {
  if (!template) return "";
  return (
    (template as Template & { identifier?: string }).identifier ?? template.id
  );
};
